import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { ComponentVideoType } from "@swo/storefront";
import { SerializedStyles } from "@emotion/react";
import { ContentfulComponentCMSHook } from "@swo/shared";
import React from "react";
import { SimpleVideoPlayerProps, SwarovskiOptikVideoPlayer } from "./VideoComponent";

export const VideoPlayerWithUi: ReactTFC<
  ComponentVideoType & {
    resolutionPickerStrategy: "middle" | "ceil" | "double-ceil";
    attachStyles?: SerializedStyles;
    mode: "fill" | "contain";
  } & ContentfulComponentCMSHook
> = props => {
  const { video, ...rest } = props;

  return (
    <SwarovskiOptikVideoPlayer
      {...rest}
      withPlayerUI={true}
      sharedVideoProps={sharedVideoProps}
      mode={props.mode}
      subtitles={video.subtitles}
      video={video.video}
    />
  );
};

const sharedVideoProps: SimpleVideoPlayerProps["sharedVideoProps"] = {
  preload: "auto",
  playsInline: "enabled-after-interaction",
  muted: false,
  crossOrigin: "crossorigin" as any,
  loop: false,
  autoPlay: false,
};
